import { render, staticRenderFns } from "./checkUser.vue?vue&type=template&id=2a10674c&scoped=true"
import script from "./checkUser.vue?vue&type=script&lang=js"
export * from "./checkUser.vue?vue&type=script&lang=js"
import style0 from "../../assets/css/enroll/checkUser.css?vue&type=style&index=0&id=2a10674c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10674c",
  null
  
)

export default component.exports